import { animate, style, transition, trigger } from '@angular/animations';
import { Component } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
	selector: 'cass-popup-panel-component',
	templateUrl: './popup-panel.component.html',
	styleUrls: ['./popup-panel.component.css'],
	animations: [
		trigger('fadeIn', [
			transition(':enter', [
				style({ opacity: 0 }),
				animate('100ms', style({ opacity: 1 })),
			])
		]),
	],
})
export class PopupPanelComponent {
	customHtmlContent: string | undefined;

	mouseLeaves$ = new Subject<void>();
	mouseEnters$ = new Subject<void>();

	notifyMouseLeave(event: MouseEvent): void {
		this.mouseLeaves$.next();
	}

	notifyMouseEnter(event: MouseEvent): void {
		this.mouseEnters$.next();
	}
}
